/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import appReducer from '../../App/appReducer';
import devicesReducer from '../../Devices/reducer';
import languageProviderReducer from '../../LanguageProvider/reducer';
import notificationReducer from '../../Notification/notificationReducer';
import reportsReducer from '../../Reports/reportsReducer';
import settingsReducer from '../../Settings/settingsReducer';
import sitesReducer from '../../Sites/reducer';
import resourcesReducer from '../../Resources/resourcesReducer';
import userReducer from '../../User/userReducer';
import chartBuilderReducer from '../../chartBuilder/reducer';
import rolesAndPermissionReducer from '../../UserRoles&Permissions/roleAndPermissionReducer';
import eventsReducer from '../../Events/reducer';
import devicesByTypeReducer from '../../DevicesByType/reducer';
import solarEnergyGeneratedReducer from '../../SolarEnergyGenerated/reducer';
import totalGreenFactorTodayReducer from '../../TotalGreenFactorToday/reducer';
import stateOfChargeReducer from '../../StateOfCharge/reducer';
import batteryLevelReducer from '../../BatteryLevel/reducer';
import powerUseVsGenerationReducer from '../../PowerUseVsGeneration/reducer';
import realPowerVsTemperatureReducer from '../../RealPowerVsTemperature/reducer';
import solarPowerVsBatteryPowerReducer from '../../SolarPowerVsBatteryPower/reducer';
import peakTodayReducer from '../../PeakToday/reducer';
import metersReducer from '../../Meters/reducer';
import localIOReducer from '../../LocalIO/reducer';
import powerFactorTrendReducer from '../../PowerFactorTrend/reducer';
import generalEquipmentEnergyTotalTrendReducer from '../../GeneralEquipmentEnergyTotalTrend/reducer';
import serviceUsageReducer from '../../ServiceUsage/reducer';
/*
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    app: appReducer,
    user: userReducer,
    settings: settingsReducer,
    language: languageProviderReducer,
    sites: sitesReducer,
    notification: notificationReducer,
    reports: reportsReducer,
    devices: devicesReducer,
    resources: resourcesReducer,
    chartBuilder: chartBuilderReducer,
    rolesAndPermission: rolesAndPermissionReducer,
    events: eventsReducer,
    devicesByType: devicesByTypeReducer,
    solarEnergyGenerated: solarEnergyGeneratedReducer,
    totalGreenFactorToday: totalGreenFactorTodayReducer,
    stateOfCharge: stateOfChargeReducer,
    batteryLevel: batteryLevelReducer,
    powerUseVsGeneration: powerUseVsGenerationReducer,
    realPowerVsTemperature: realPowerVsTemperatureReducer,
    solarPowerVsBatteryPower: solarPowerVsBatteryPowerReducer,
    peakToday: peakTodayReducer,
    meters: metersReducer,
    localIO: localIOReducer,
    powerFactorTrend: powerFactorTrendReducer,
    generalEquipmentEnergyTotalTrend: generalEquipmentEnergyTotalTrendReducer,
    serviceUsage: serviceUsageReducer,
    ...injectedReducers,
  });
}
